const PAGE_SIZE = 20;

export const actionTypes = {
	SetLoading: '[Story] SetLoading',
	AddPosts: '[Story] SavePosts',
	SetPosts: '[Story] SetPosts',
};

export const initialStoryState = {
	posts: [],
	storyPosts: [],
	loading: false,
	allLoaded: false,
};

export const reducer = (state = initialStoryState, action) => {
	switch (action.type) {
		case actionTypes.SetLoading:
			return {
				...state,
				loading: action.payload,
			};
		case actionTypes.AddPosts:
			return {
				...state,
				posts: [...state.posts, ...action.payload.result],
				loading: false,
				allLoaded: action.payload.length < PAGE_SIZE,
			};
		case actionTypes.SetPosts:
			return {
				...state,
				posts: action.payload.result || [],
				storyPosts: action.payload.storyPosts || [],
				loading: false,
				allLoaded: action.payload.length < PAGE_SIZE,
			};
		default:
			return state;
	}
};

export const actions = {
	addPosts: payload => ({ type: actionTypes.AddPosts, payload }),
	setPosts: payload => ({ type: actionTypes.SetPosts, payload }),
	setLoading: payload => ({ type: actionTypes.SetLoading, payload }),
};
